import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../services/session.service';
import { Router } from '@angular/router';

declare var jQuery: any;
declare var $: any;
declare var Faqs: any;

@Component({
    selector: 'app-faqValoriza',
    templateUrl: './faqValoriza.component.html'
})


export class FaqValorizaComponent implements OnInit {

    public title: string;

    constructor(public router: Router, public sessionService: SessionService) { }

    ngOnInit() {
      Faqs.init();
    }

    public Volver() {
        if (this.sessionService.contratos !== undefined) {
            this.router.navigate(['/home/home']);
        } else {
            this.router.navigate(['/public/login']);
        }
    }
}
